import { FormControl } from '@angular/forms';


export interface ListItem<T> {
  id?: string;
  image?: string | null;
  text: string;
  description?: string | null;
  action: ListItemAction;
  archived: boolean;
  archivedText: string;
  item: T;
  selected: boolean;
}

export interface ListItemAction {
  type: ActionTypeEnum;
  checked?: boolean;
  disabled?: boolean;
}

export enum ActionTypeEnum {
  checkbox = 'checkbox',
}

